$(function () {
	// Events on map
	$('.geo-map__hov').on('mouseenter touchstart',function () {
		const id = $(this).data('country');

		$(`[data-coun='${id}']`)
			.addClass('is-active');

		$(`.geo-map__item[data-country='${id}']`)
			.remove()
			.appendTo('.geo-map__map');

		setTimeout(function () {
			$(`.geo-map__item[data-country='${id}']`).addClass('active');
		},100);

		$(`.pin__item--${id}`).addClass('active');

	}).on('mouseleave',function () {
		const id = $(this).data('country');

		setTimeout(function () {
			$(`.geo-map__item[data-country='${id}']`).removeClass('active');
		},100);
		$(`[data-coun='${id}']`).removeClass('is-active');
		$(`.pin__item--${id}`).removeClass('active');
	});

	// Events on list
	$('.about-page-geo__link').on('mouseenter touchstart',function () {
		const id = $(this).data('coun');

		$(`.geo-map__item[data-country='${id}']`)
			.addClass('active')
			.remove()
			.appendTo('.geo-map__map');

		$(`.pin__item--${id}`).addClass('active');

	}).on('mouseleave',function () {
		const id = $(this).data('coun');

		$(`.geo-map__item[data-country='${id}']`).removeClass('active');
		$(`.pin__item--${id}`).removeClass('active');
	});
});
